/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Offset_SubtractInputs */



/**
* | output |
* | --- |
* | "Subtract" |
*
* @param {Transcript_Export_Offset_SubtractInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_offset_subtract = /** @type {((inputs?: Transcript_Export_Offset_SubtractInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Offset_SubtractInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soustraire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Subtrahieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottrarre")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вычесть")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sustraer")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("减去")
	if (locale === "ja") return /** @type {LocalizedString} */ ("減算")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Subtrair")
	return /** @type {LocalizedString} */ ("Subtract")
});